import React from 'react'

const CONFIG_ELEMENTS = [
  {
    type: 'columns',
    itemType: 'element',
    category: 'content',
    title: 'Spalten Element',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.583" viewBox="0 0 24 23.583"><path d="M34.428,12.59H25.189a.3.3,0,0,0-.3.3.3.3,0,0,0,.3.3h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -6.618)"/><path d="M34.428,19.56H25.189a.3.3,0,0,0,0,.6h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -10.283)"/><path d="M34.428,26.53H25.189a.3.3,0,0,0,0,.6h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -13.947)"/><path d="M12.483,19.886l.076-.052.028-.033h0a.171.171,0,0,0,0-.043V19.7h0a.1.1,0,0,0,0-.028v-6.74l-.024-.028v-.028H12.54l-.133-.071H5.141l-.076.057h0v.028A.1.1,0,0,0,5,12.895v.062H5a.1.1,0,0,0,0,.028v.066H5v6.692a.071.071,0,0,1,0,.028v.033l.028.028.076.052H12.45ZM11.369,13.3,8.817,15.949,6.265,13.3Zm-5.791.261,2.7,2.746-2.7,2.756Zm.688,5.753,2.552-2.651,2.552,2.651Zm5.791-.251-2.7-2.751,2.7-2.746Z" transform="translate(-2.627 -6.729)"/><path d="M5.227,34.06H23.915a.3.3,0,0,0,0-.593H5.227a.3.3,0,1,0,0,.593Z" transform="translate(-2.571 -17.592)"/><path d="M5.269,41.248H23.957a.3.3,0,0,0,0-.6H5.269a.3.3,0,0,0,0,.6Z" transform="translate(-2.613 -21.369)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(20.964 1.57)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(19.394 1.57)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(17.824 1.57)"/><path d="M24,22.349V1.081A1.1,1.1,0,0,0,22.914,0H1.1A1.1,1.1,0,0,0,0,1.086V22.5a1.1,1.1,0,0,0,1.086,1.081H22.9A1.228,1.228,0,0,0,24,22.349ZM.6,1.081A.474.474,0,0,1,1.072.607H22.89a.474.474,0,0,1,.474.474V3.14H.6ZM1.072,22.99A.474.474,0,0,1,.6,22.515V3.738H23.4V22.349c0,.256-.2.64-.474.64Z"/></svg>,
    settings: {
      sections: [
        {
          headline: 'Spalten',
          fields: [
            {
              type: 'repeater',
              name: 'columns',
              label: 'Spalten',
              addItemLabel: 'Spalte hinzufügen',
              maxItems: 4,
              fields: [
                {
                  type: 'column_elements',
                  name: 'elements',
                  label: 'Elemente'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'text',
    itemType: 'column-element',
    category: 'content',
    title: 'Text',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.583" viewBox="0 0 24 23.583"><path d="M34.428,12.59H25.189a.3.3,0,0,0-.3.3.3.3,0,0,0,.3.3h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -6.618)"/><path d="M34.428,19.56H25.189a.3.3,0,0,0,0,.6h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -10.283)"/><path d="M34.428,26.53H25.189a.3.3,0,0,0,0,.6h9.239a.3.3,0,0,0,0-.6Z" transform="translate(-13.084 -13.947)"/><path d="M12.483,19.886l.076-.052.028-.033h0a.171.171,0,0,0,0-.043V19.7h0a.1.1,0,0,0,0-.028v-6.74l-.024-.028v-.028H12.54l-.133-.071H5.141l-.076.057h0v.028A.1.1,0,0,0,5,12.895v.062H5a.1.1,0,0,0,0,.028v.066H5v6.692a.071.071,0,0,1,0,.028v.033l.028.028.076.052H12.45ZM11.369,13.3,8.817,15.949,6.265,13.3Zm-5.791.261,2.7,2.746-2.7,2.756Zm.688,5.753,2.552-2.651,2.552,2.651Zm5.791-.251-2.7-2.751,2.7-2.746Z" transform="translate(-2.627 -6.729)"/><path d="M5.227,34.06H23.915a.3.3,0,0,0,0-.593H5.227a.3.3,0,1,0,0,.593Z" transform="translate(-2.571 -17.592)"/><path d="M5.269,41.248H23.957a.3.3,0,0,0,0-.6H5.269a.3.3,0,0,0,0,.6Z" transform="translate(-2.613 -21.369)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(20.964 1.57)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(19.394 1.57)"/><circle cx="0.299" cy="0.299" r="0.299" transform="translate(17.824 1.57)"/><path d="M24,22.349V1.081A1.1,1.1,0,0,0,22.914,0H1.1A1.1,1.1,0,0,0,0,1.086V22.5a1.1,1.1,0,0,0,1.086,1.081H22.9A1.228,1.228,0,0,0,24,22.349ZM.6,1.081A.474.474,0,0,1,1.072.607H22.89a.474.474,0,0,1,.474.474V3.14H.6ZM1.072,22.99A.474.474,0,0,1,.6,22.515V3.738H23.4V22.349c0,.256-.2.64-.474.64Z"/></svg>,
    helpVideo: '448967860',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'wysiwyg',
              name: 'text',
              label: 'Text'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'image',
    itemType: 'column-element',
    category: 'content',
    title: 'Bild',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18.028" viewBox="0 0 24 18.028"><path d="M24,18.028H0V0H24ZM.614,17.414H23.386V.614H.614Z" /><path d="M8.149,14.611,4.3,10.76l-3.7,3.7L.16,14.029,4.3,9.891l3.851,3.851,7.825-7.825,7.936,7.936-.434.434-7.5-7.5Z" /><path d="M8.233,9.014A3.237,3.237,0,1,1,11.47,5.777,3.237,3.237,0,0,1,8.233,9.014Zm0-5.86a2.623,2.623,0,1,0,2.623,2.623A2.623,2.623,0,0,0,8.233,3.153Z" /></svg>,
    helpVideo: '448967150',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'image',
              name: 'image',
              label: 'Bild'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'audio',
    itemType: 'column-element',
    category: 'content',
    title: 'Audio',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21.822" viewBox="0 0 24 21.822"><path d="M10.459,21.45A1.008,1.008,0,0,1,9.8,21.2h0L5.333,16.484H1.017A1.018,1.018,0,0,1,0,15.434V9.473A1.018,1.018,0,0,1,1.017,8.455h4.3L9.767,3.7a1.022,1.022,0,0,1,1.715.744v16.02a1.008,1.008,0,0,1-.6.942,1.027,1.027,0,0,1-.424.047Zm-.283-.674a.471.471,0,0,0,.74-.349V4.408a.471.471,0,0,0-.754-.339l-4.6,4.952H1.017a.471.471,0,0,0-.471.471v5.942a.471.471,0,0,0,.471.471H5.559Z" transform="translate(0.001 -1.811)"/><path d="M28.425,22.724a.311.311,0,0,0,.226-.033,4.175,4.175,0,0,0,.678-.561,3.9,3.9,0,0,0,0-5.5,3.8,3.8,0,0,0-.721-.57.273.273,0,0,0-.155-.047h-.071a.273.273,0,0,0-.184.137.283.283,0,0,0-.038.221.292.292,0,0,0,.137.188,3.31,3.31,0,0,1,.608,5.155,3.543,3.543,0,0,1-.57.471.273.273,0,0,0-.132.184.292.292,0,0,0,.038.226A.306.306,0,0,0,28.425,22.724Z" transform="translate(-14.887 -8.465)"/><path d="M36.558,15.152A8.067,8.067,0,0,0,32.238,7.99a.278.278,0,0,0-.137,0h-.09a.316.316,0,0,0-.179.151.3.3,0,0,0,.127.4,7.463,7.463,0,0,1,1.819,11.883,7.341,7.341,0,0,1-1.8,1.333.283.283,0,0,0-.146.174.292.292,0,0,0,.024.226.283.283,0,0,0,.174.146.311.311,0,0,0,.226,0h0A8.185,8.185,0,0,0,34.2,20.868,8.01,8.01,0,0,0,36.558,15.152Z" transform="translate(-16.816 -4.22)"/><path d="M36.554,21.772A12.312,12.312,0,0,0,36.483.032.278.278,0,0,0,36.323,0a.3.3,0,0,0-.264.16.292.292,0,0,0-.024.226.283.283,0,0,0,.146.174,11.845,11.845,0,0,1,2.827,2.092,11.713,11.713,0,0,1-2.742,18.593.306.306,0,0,0-.146.179.292.292,0,0,0,0,.226.3.3,0,0,0,.433.123Z" transform="translate(-19.049 0.003)"/></svg>,
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'audio',
              name: 'audio',
              label: 'Audio'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'video',
    itemType: 'element',
    category: 'content',
    title: 'Video',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18.028" viewBox="0 0 24 18.028"><path d="M24,18.028H0V0H24ZM.614,17.414H23.386V.614H.614Z" /><path d="M8.149,14.611,4.3,10.76l-3.7,3.7L.16,14.029,4.3,9.891l3.851,3.851,7.825-7.825,7.936,7.936-.434.434-7.5-7.5Z" /><path d="M8.233,9.014A3.237,3.237,0,1,1,11.47,5.777,3.237,3.237,0,0,1,8.233,9.014Zm0-5.86a2.623,2.623,0,1,0,2.623,2.623A2.623,2.623,0,0,0,8.233,3.153Z" /></svg>,
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'video',
              name: 'video',
              label: 'Video'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'introslider',
    itemType: 'element',
    category: 'content',
    title: 'Introslider',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="34.677" height="21" viewBox="0 0 41.677 21"><path d="M2536.033,767h24.246a1.357,1.357,0,0,0,1.246-1.438V747.438A1.357,1.357,0,0,0,2560.28,746h-24.433a1.357,1.357,0,0,0-1.246,1.438v18.123A1.512,1.512,0,0,0,2536.033,767Zm24.246-20.209a.606.606,0,0,1,.561.647h0v18.123a.606.606,0,0,1-.561.647h-24.246c-.312,0-.748-.288-.748-.647V747.438a.606.606,0,0,1,.561-.647h24.433Z" transform="translate(-2526.975 -746)"/><path d="M2580.3,766.5c-.1,0-.3-.1-.4-.1a.483.483,0,0,1,0-.7l4-4-4-4a.495.495,0,0,1,.7-.7l4.1,4.1a.91.91,0,0,1,0,1.2l-4.1,4.1C2580.5,766.4,2580.4,766.5,2580.3,766.5Z" transform="translate(-2543.249 -750.551)"/><path d="M2531.7,766.5a.6.6,0,0,1-.4-.1l-4.1-4.1a.91.91,0,0,1,0-1.2l4.1-4.1a.495.495,0,0,1,.7.7h0l-4,4,4,4a.483.483,0,0,1,0,.7h0a1.009,1.009,0,0,1-.3.1Z" transform="translate(-2526.975 -750.551)"/><line x2="25.026" y2="18.8" transform="translate(8.225 0.8)" strokeMiterlimit="10" strokeWidth="1"/><line x1="25.026" y2="18.8" transform="translate(8.125 1.3)" strokeMiterlimit="10" strokeWidth="1"/></svg>,
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'repeater',
              name: 'slides',
              label: 'Slides',
              addItemLabel: 'Slide hinzufügen',
              fields: [
                {
                  type: 'image',
                  name: 'image',
                  label: 'Bild'
                },
                {
                  type: 'textarea',
                  name: 'headline',
                  label: 'Titel'
                },
                {
                  type: 'textarea',
                  name: 'text',
                  label: 'Text'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'instruction',
    itemType: 'element',
    category: 'content',
    title: 'Anweisung',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.63" viewBox="0 0 24 23.63"><path d="M6.061,23.63V20.048H2.812A2.812,2.812,0,0,1,0,17.391V2.658A2.658,2.658,0,0,1,2.658,0H21.342A2.658,2.658,0,0,1,24,2.658V17.391a2.658,2.658,0,0,1-2.658,2.658H10.561ZM2.658.563a2.1,2.1,0,0,0-2.1,2.1V17.391a2.245,2.245,0,0,0,2.25,2.1h3.8v2.981l3.75-2.981H21.342a2.1,2.1,0,0,0,2.1-2.1V2.658a2.1,2.1,0,0,0-2.1-2.1Z" transform="translate(0 0)"/><path d="M25.562,16.754a.281.281,0,0,1-.563,0v-9.4a.281.281,0,1,1,.562,0Z" transform="translate(-13.281 -3.756)"/><path d="M25.562,32.848a.281.281,0,0,1-.563,0v-.5a.281.281,0,1,1,.562,0Z" transform="translate(-13.281 -17.037)"/></svg>,
    settings: {
      sections: [
        {
          headline: 'Bild',
          fields: [
            {
              type: 'image',
              name: 'image',
              label: 'Bild'
            }
          ]
        },
        {
          headline: 'Audio',
          fields: [
            {
              type: 'audio',
              name: 'audio',
              label: 'Audio'
            }
          ]
        },
        {
          headline: 'Text',
          fields: [
            {
              type: 'textarea',
              name: 'text',
              label: 'Text'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'teasers',
    itemType: 'element',
    category: 'content',
    title: 'Teaser',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24.124" viewBox="0 0 24 24.124"><path d="M11.225,22.887V1.084A1.1,1.1,0,0,0,10.136,0H1.1A1.1,1.1,0,0,0,0,1.089v21.95a1.1,1.1,0,0,0,1.089,1.084h9.037A1.232,1.232,0,0,0,11.225,22.887ZM.6,1.084A.476.476,0,0,1,1.075.609h9.037a.476.476,0,0,1,.476.476v21.8c0,.257-.2.642-.476.642H1.075A.476.476,0,0,1,.6,23.053Z"/><path d="M7,4.7H11.6a.285.285,0,1,1,0,.571H7A.285.285,0,0,1,7,4.7Z" transform="translate(-3.519 -2.465)"/><rect width="0.571" height="25.355" transform="translate(0.354 0.595) rotate(-23.2)"/><rect width="25.355" height="0.571" transform="translate(0.357 23.679) rotate(-66.8)"/><path d="M5,28.7h6.036a.285.285,0,0,1,0,.571H5A.285.285,0,0,1,5,28.7Z" transform="translate(-2.47 -15.05)"/><path d="M5,33.7h6.036a.285.285,0,0,1,0,.571H5A.285.285,0,0,1,5,33.7Z" transform="translate(-2.47 -17.672)"/><path d="M5,38.7h6.036a.285.285,0,1,1,0,.571H5A.285.285,0,1,1,5,38.7Z" transform="translate(-2.47 -20.293)"/><path d="M5,43.7h6.036a.285.285,0,0,1,0,.571H5A.285.285,0,0,1,5,43.7Z" transform="translate(-2.47 -22.915)"/><path d="M38.1,22.887V1.084A1.1,1.1,0,0,0,37.011,0H27.974A1.1,1.1,0,0,0,26.89,1.089v21.95a1.1,1.1,0,0,0,1.084,1.084h9.037A1.232,1.232,0,0,0,38.1,22.887ZM27.47,1.084a.476.476,0,0,1,.476-.476h9.037a.476.476,0,0,1,.476.476v7.3H27.47Zm.476,22.445a.476.476,0,0,1-.476-.476V8.98H37.5V22.887c0,.257-.2.642-.476.642Z" transform="translate(-14.101)"/><path d="M32,23.7h6.036a.285.285,0,1,1,0,.571H32a.285.285,0,1,1,0-.571Z" transform="translate(-16.628 -12.428)"/><path d="M32,28.7h6.036a.285.285,0,1,1,0,.571H32a.285.285,0,1,1,0-.571Z" transform="translate(-16.628 -15.05)"/><path d="M32,33.7h6.036a.285.285,0,1,1,0,.571H32a.285.285,0,1,1,0-.571Z" transform="translate(-16.628 -17.672)"/><path d="M32,38.7h6.036a.285.285,0,1,1,0,.571H32a.285.285,0,1,1,0-.571Z" transform="translate(-16.628 -20.293)"/><path d="M32,43.7h6.036a.285.285,0,0,1,0,.571H32a.285.285,0,0,1,0-.571Z" transform="translate(-16.628 -22.915)"/><rect width="0.571" height="12.851" transform="matrix(0.629, -0.777, 0.777, 0.629, 13.316, 0.706)"/><rect width="12.851" height="0.571" transform="translate(13.312 8.347) rotate(-38.96)"/></svg>,
    helpVideo: '448967799',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'repeater',
              name: 'teasers',
              label: 'Teaser',
              addItemLabel: 'Teaser hinzufügen',
              maxItems: 3,
              fields: [
                {
                  type: 'teaser_types',
                  name: 'type',
                  label: 'Teaserauswahl',
                  defaultValue: 'small-image-text'
                },
                {
                  type: 'textarea',
                  name: 'headline',
                  label: 'Titel'
                },
                {
                  type: 'textarea',
                  name: 'text',
                  label: 'Text'
                },
                {
                  type: 'image',
                  name: 'image',
                  label: 'Bild'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                },
                {
                  settings: {}
                },
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'hotspots',
    itemType: 'element',
    category: 'content',
    title: 'Hotspots',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.15,42.966a3.633,3.633,0,1,1,1.308-7.031l.248.108-.239.506-.216-.089a3.067,3.067,0,1,0,.919.553l.37-.427A3.633,3.633,0,0,1,6.15,42.952Z" transform="translate(-1.35 -18.966)"/><rect width="0.563" height="3.075" transform="translate(4.584 18.769)"/><rect width="3.075" height="0.563" transform="translate(3.328 20.025)"/><path d="M6.061,19.106V13.95H2.813A2.812,2.812,0,0,1,0,11.3V2.658A2.658,2.658,0,0,1,2.658,0H21.342A2.658,2.658,0,0,1,24,2.658V11.3a2.658,2.658,0,0,1-2.658,2.658H10.608ZM2.658.563a2.1,2.1,0,0,0-2.1,2.1V11.3a2.245,2.245,0,0,0,2.25,2.1h3.8v4.219l3.727-4.219H21.342a2.1,2.1,0,0,0,2.1-2.1V2.658a2.1,2.1,0,0,0-2.1-2.1Z"/></svg>,
    helpVideo: '448967324',
    settings: {
      sections: [
        {
          headline: 'Bild',
          fields: [
            {
              type: 'image',
              name: 'image',
              label: 'Bild'
            }
          ]
        },
        {
          headline: 'Hotspots',
          fields: [
            {
              type: 'repeater',
              name: 'hotspots',
              label: 'Hotspots',
              addItemLabel: 'Hotspot hinzufügen',
              fields: [
                {
                  type: 'coordinates',
                  name: 'position',
                  label: 'Position',
                  defaultValue: {
                    x: '50',
                    y: '50'
                  }
                },
                {
                  type: 'textarea',
                  name: 'text',
                  label: 'Inhalt'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'slider',
    itemType: 'element',
    category: 'content',
    title: 'Slider',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22.511" viewBox="0 0 24 22.511"><path d="M25.152,21.333V1.032A1.046,1.046,0,0,0,24.12,0H10.99A1.05,1.05,0,0,0,9.94,1.037V21.478a1.046,1.046,0,0,0,1.037,1.032h13.13a1.173,1.173,0,0,0,1.046-1.177ZM10.51,1.032A.453.453,0,0,1,10.963.58h13.13a.453.453,0,0,1,.453.453v20.3c0,.244-.195.611-.453.611H10.963a.453.453,0,0,1-.453-.453Z" transform="translate(-5.447)"/><rect width="0.543" height="17.376" transform="translate(4.739 0.613) rotate(-54.93)"/><rect width="17.376" height="0.543" transform="translate(4.739 10.153) rotate(-35.06)"/><path d="M47.268,25.491a.285.285,0,0,1-.195-.077.276.276,0,0,1,0-.385l2.1-2.092-2.1-2.069a.272.272,0,0,1,.385-.385l2.151,2.123a.5.5,0,0,1,0,.643l-2.16,2.164A.263.263,0,0,1,47.268,25.491Z" transform="translate(-25.725 -11.166)"/><path d="M2.481,25.515a.267.267,0,0,1-.208-.077L.136,23.315a.493.493,0,0,1,0-.643l2.137-2.146a.276.276,0,0,1,.385,0,.272.272,0,0,1,0,.385L.571,22.984l2.1,2.069a.272.272,0,0,1,0,.385.276.276,0,0,1-.19.077Z" transform="translate(-0.017 -11.19)"/><path d="M25.466,36.5c.1,0,.186-.122.186-.272s-.081-.272-.186-.272H15.37c-.109,0-.19.122-.19.272s.081.272.19.272Z" transform="translate(-8.315 -19.679)"/><path d="M25.466,30.169c.1,0,.186-.118.186-.267s-.081-.272-.186-.272H15.37c-.109,0-.19.122-.19.272s.081.267.19.267Z" transform="translate(-8.315 -16.215)"/><path d="M24.9,23.169a.263.263,0,0,0,.263-.267.267.267,0,0,0-.263-.272H10.413a.267.267,0,0,0-.263.272.263.263,0,0,0,.263.267Z" transform="translate(-5.562 -12.384)"/><path d="M25.466,42.839c.1,0,.186-.122.186-.272s-.081-.267-.186-.267H15.37c-.109,0-.19.122-.19.267s.081.272.19.272Z" transform="translate(-8.315 -23.149)"/></svg>,
    helpVideo: '448967774',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'repeater',
              name: 'slides',
              label: 'Slides',
              addItemLabel: 'Slide hinzufügen',
              fields: [
                {
                  type: 'image',
                  name: 'image',
                  label: 'Bild'
                },
                {
                  type: 'textarea',
                  name: 'headline',
                  label: 'Titel'
                },
                {
                  type: 'textarea',
                  name: 'text',
                  label: 'Text'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'lenticular_slider',
    itemType: 'element',
    category: 'content',
    title: 'Lentikular Slider',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.643" viewBox="0 0 24 23.643"><path d="M23.978,22.842V11.07C24.073,10,23.5,9.995,22.424,10H1.084C.965,10-.1,10-.006,11.075V22.994a1.1,1.1,0,0,0,1.09,1.081h21.8a1.227,1.227,0,0,0,1.095-1.232Zm-.592,0c0,.256-.209.635-.474.635H1.084A.474.474,0,0,1,.61,23V11.07a.474.474,0,0,1,.474-.474h21.8a.474.474,0,0,1,.474.474Z" transform="translate(0.011 -5.26)"/><path d="M24.72,29.74V39a.284.284,0,0,0,.284.284.28.28,0,0,0,.28-.284V29.749Z" transform="translate(-13 -15.646)"/><path d="M24.72,9.3V.284A.284.284,0,0,1,25,0a.28.28,0,0,1,.28.284v9Z" transform="translate(-13 0)"/><path d="M22.242,24.325a2.772,2.772,0,1,1,2.772-2.772A2.772,2.772,0,0,1,22.242,24.325Zm0-4.976a.914.914,0,1,1,0,.009Z" transform="translate(-10.238 -9.88)"/><path d="M23.953,24.463a.289.289,0,0,1-.2-.085.284.284,0,0,1,0-.4l1.066-1.052L23.749,21.88a.289.289,0,0,1,0-.4.284.284,0,0,1,.4,0l1.175,1.152a.445.445,0,0,1,0,.573l-1.175,1.18a.261.261,0,0,1-.2.081Z" transform="translate(-12.446 -11.255)"/><path d="M6.1,10.744V23.866a.284.284,0,1,0,.564,0V10.744a.284.284,0,1,0-.564,0Z" transform="translate(-3.201 -5.483)"/><path d="M2.45,10.784V23.907a.284.284,0,0,0,.569,0V10.784a.284.284,0,1,0-.569,0Z" transform="translate(-1.284 -5.524)"/><path d="M11.1,10.744V23.866a.284.284,0,1,0,.564,0V10.744a.284.284,0,1,0-.564,0Z" transform="translate(-5.832 -5.483)"/><path d="M17.1,10.744V23.866a.284.284,0,1,0,.564,0V10.744a.284.284,0,1,0-.564,0Z" transform="translate(-8.988 -5.483)"/><path d="M35.1,10.744V23.866a.284.284,0,1,0,.564,0V10.744a.284.284,0,1,0-.564,0Z" transform="translate(-18.458 -5.483)"/></svg>,
    helpVideo: '448967466',
    settings: {
      sections: [
        {
          headline: 'Vorher-Bild',
          fields: [
            {
              type: 'image',
              name: 'image_left',
              label: 'Vorher-Bild'
            }
          ]
        },
        {
          headline: 'Nacher-Bild',
          fields: [
            {
              type: 'image',
              name: 'image_right',
              label: 'Nacher-Bild'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'accordion',
    itemType: 'element',
    category: 'content',
    title: 'Akkordeon',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22.829" viewBox="0 0 24 22.829"><rect width="17.486" height="0.617" transform="translate(0 1.278)" /><rect width="23.763" height="0.617" transform="translate(0 4.642)" /><rect width="23.763" height="0.617" transform="translate(0 6.939)" /><path d="M19.475,2.937,19.039,2.5l2.5-2.5L24,2.5l-.44.432L21.537.876Z" /><rect width="17.486" height="0.617" transform="translate(0 13.104)" /><path d="M21.5,14.983l-2.459-2.5.44-.432,2.023,2.06,2.061-2.062.436.436Z" /><rect width="23.763" height="0.617" transform="translate(0 9.181)" /><rect width="17.486" height="0.617" transform="translate(0 17.027)" /><path d="M21.5,18.906l-2.459-2.5.44-.432,2.023,2.06,2.061-2.062L24,16.4Z" /><rect width="17.486" height="0.617" transform="translate(0 20.95)" /><path d="M21.5,22.829l-2.459-2.5.44-.432,2.023,2.06,2.061-2.062.436.436Z" /></svg>,
    helpVideo: '448967073',
    settings: {
      sections: [
        {
          fields: [
            {
              type: 'repeater',
              name: 'sections',
              label: 'Sektionen',
              addItemLabel: 'Sektion hinzufügen',
              fields: [
                {
                  type: 'textarea',
                  name: 'headline',
                  label: 'Titel'
                },
                {
                  type: 'wysiwyg',
                  name: 'text',
                  label: 'Text'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'drag_and_drop',
    itemType: 'element',
    category: 'quiz',
    title: 'Drag & Drop',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.399" viewBox="0 0 24 23.399"><path d="M25.216,14.9H13.573V.572H27.9V13.25l.578.2V.465A.466.466,0,0,0,27.992,0h-14.5A.466.466,0,0,0,13,.465V15a.466.466,0,0,0,.489.466H25.356Z" transform="translate(-6.945 0.001)"/><path d="M13.607,20.1l-.447-.335,4.238-5.58,1.849,1.849,3.735-5.607,5.472,6.134-.415.373-4.993-5.593-3.717,5.57-1.877-1.877Z" transform="translate(-7.03 -5.572)"/><path d="M19.642,8.785a2.142,2.142,0,1,1,2.142-2.142,2.142,2.142,0,0,1-2.142,2.142Zm0-3.726a1.584,1.584,0,1,0,1.584,1.584,1.584,1.584,0,0,0-1.584-1.584Z" transform="translate(-9.349 -2.404)"/><path d="M38.511,32.547,36.42,25.51,43.457,27.6l-1.784,1.784,1.649,1.644-1.4,1.4L40.29,30.768Zm1.779-2.571,1.649,1.644.591-.591-1.649-1.644,1.509-1.514-5.123-1.532L38.8,31.49Z" transform="translate(-19.457 -13.628)"/><rect width="2.138" height="0.48" transform="translate(3.307 7.965)"/><path d="M9.231,17.573H7V17H9.231Zm-2.138-.107H9.138v-.373H7.093Z" transform="translate(-3.739 -9.082)"/><rect width="0.48" height="2.138" transform="translate(0.047 11.225)"/><path d="M.568,26.231H0V24H.568ZM.1,26.138H.466V24.093H.093Z" transform="translate(0.001 -12.822)"/><rect width="0.48" height="2.138" transform="translate(0.047 14.485)"/><path d="M.568,33.231H0V31H.568ZM.1,33.138H.466V31.093H.093Z" transform="translate(0.001 -16.562)"/><path d="M1.9,48.249H.5a.466.466,0,0,1-.438-.466V46.6H.526v1.164H1.9Z" transform="translate(-0.031 -24.896)"/><path d="M1.914,48.242H.465A.466.466,0,0,1,0,47.753V46.5H.568v1.164H1.914ZM.092,46.593v1.16a.4.4,0,0,0,.373.377H1.82v-.373H.465V46.593Z" transform="translate(0.001 -24.843)"/><rect width="0.48" height="2.138" transform="translate(0.047 17.955)"/><path d="M.568,40.681H0V38.45H.568Zm-.475-.112H.466V38.543H.093Z" transform="translate(0.001 -20.542)"/><rect width="2.138" height="0.48" transform="translate(3.307 22.873)"/><path d="M9.231,49.578H7V49H9.231Zm-2.138-.112H9.138v-.387H7.093Z" transform="translate(-3.739 -26.178)"/><path d="M.1,18.9V17.5a.466.466,0,0,1,.466-.438H1.749v.466H.584V18.9Z" transform="translate(-0.053 -9.114)"/><path d="M.578,18.914H0V17.465A.466.466,0,0,1,.489,17H1.742v.573H.578ZM.112,18.82H.466V17.465H1.63v-.373H.489a.4.4,0,0,0-.4.373Z" transform="translate(0.001 -9.081)"/><rect width="2.138" height="0.48" transform="translate(6.586 22.873)"/><path d="M16.25,49.578H14V49h2.231Zm-2.138-.112h2.045v-.387H14.112Z" transform="translate(-7.479 -26.178)"/><path d="M31.289,46.23v1.4a.466.466,0,0,1-.466.438H29.64V47.6H30.8V46.23Z" transform="translate(-15.835 -24.698)"/><path d="M30.793,48.044H29.54v-.578h1.146V46.13h.578v1.43a.466.466,0,0,1-.47.484Zm-1.16-.112h1.16a.4.4,0,0,0,.4-.391V46.223H30.8v1.341H29.633Z" transform="translate(-15.782 -24.645)"/><rect width="2.138" height="0.48" transform="translate(10.056 22.873)"/><path d="M23.721,49.578H21.49V49h2.231Zm-2.138-.112h2.045v-.387H21.583Z" transform="translate(-11.481 -26.178)"/><rect width="0.48" height="2.138" transform="translate(14.974 17.955)"/><path d="M32.623,40.681H32.05V38.45h.573Zm-.466-.093h.387V38.543h-.387Z" transform="translate(-17.123 -20.542)"/><rect width="0.48" height="1.206" transform="translate(14.974 15.16)"/><path d="M32.623,33.749H32.05v-1.3h.573Zm-.466-.093h.387V32.543h-.387Z" transform="translate(-17.123 -17.336)"/></svg>,
    helpVideo: '448967233',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            }
          ]
        },
        {
          headline: 'Felder',
          fields: [
            {
              type: 'repeater',
              name: 'fields',
              label: 'Felder',
              simplified: true,
              addItemLabel: 'Feld hinzufügen',
              maxItems: 4,
              fields: [
                {
                  type: 'text',
                  name: 'field',
                  label: 'Feld'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                }
              ]
            }
          ]
        },
        {
          headline: 'Karten',
          fields: [
            {
              type: 'repeater',
              name: 'cards',
              label: 'Karten',
              addItemLabel: 'Karte hinzufügen',
              fields: [
                {
                  type: 'text',
                  name: 'text',
                  label: 'Text'
                },
                {
                  type: 'select',
                  name: 'field',
                  label: 'Feld',
                  options: 'fields.field'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'multiple_choice',
    itemType: 'element',
    category: 'quiz',
    title: 'Multiple Choice',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17.511" viewBox="0 0 24 17.511"><path d="M13.018,32.23a.283.283,0,0,1-.288-.283.288.288,0,0,1,.288-.288H30.3a.288.288,0,0,1,.288.288.283.283,0,0,1-.288.283Z" transform="translate(-6.628 -16.484)"/><path d="M3.921,31.74H.532A.532.532,0,0,1,0,31.213V27.857a.532.532,0,0,1,.532-.527H3.921a.532.532,0,0,1,.532.527v3.355A.532.532,0,0,1,3.921,31.74ZM.566,31.165H3.873v-3.26H.58Z" transform="translate(0 -14.229)"/><path d="M13.018,18.57a.288.288,0,0,1-.288-.288A.283.283,0,0,1,13.018,18H30.3a.283.283,0,0,1,.288.283.288.288,0,0,1-.288.288Z" transform="translate(-6.628 -9.372)"/><path d="M3.921,18.08H.532A.532.532,0,0,1,0,17.553V14.2a.532.532,0,0,1,.532-.527H3.921a.532.532,0,0,1,.532.527v3.355A.532.532,0,0,1,3.921,18.08ZM.566,17.5H3.873v-3.26H.58Z" transform="translate(0 -7.117)"/><rect width="4.933" height="0.575" transform="matrix(0.711, -0.703, 0.703, 0.711, 0.272, 10.286)"/><rect width="0.575" height="4.933" transform="translate(0.274 7.226) rotate(-45.28)"/><path d="M12.977,4.9a.288.288,0,1,1,0-.57H30.263a.288.288,0,1,1,0,.57Z" transform="translate(-6.588 -2.252)"/><path d="M3.921,4.41H.532A.532.532,0,0,1,0,3.883V.527A.532.532,0,0,1,.532,0H3.921a.532.532,0,0,1,.532.527V3.883A.532.532,0,0,1,3.921,4.41ZM.58,3.835H3.873V.575H.58Z" transform="translate(0)"/></svg>,
    helpVideo: '448967487',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            }
          ]
        },
        {
          headline: 'Antworten',
          fields: [
            {
              type: 'repeater',
              name: 'answers',
              label: 'Antworten',
              addItemLabel: 'Antworten hinzufügen',
              fields: [
                {
                  type: 'text',
                  name: 'text',
                  label: 'Text'
                },
                {
                  type: 'select',
                  name: 'field',
                  label: 'Feld',
                  options: [
                    {
                      valie: 'right',
                      name: 'Richtig'
                    },
                    {
                      valie: 'right',
                      name: 'Falsch'
                    },
                    {
                      valie: 'partly-right',
                      name: 'Teilweise richtig'
                    }
                  ]
                },
                {
                  type: 'overlay',
                  name: 'overlay',
                  label: 'Overlay'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                },
                {
                  settings: {}
                },
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'free_text_field',
    itemType: 'element',
    category: 'quiz',
    title: 'Freitextfeld',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><rect width="0.497" height="2.194" transform="translate(0.048 18.32)"/><path d="M.593,40.505H0V38.22H.593Zm-.478-.1H.478V38.316H.1Z" transform="translate(0 -19.947)"/><rect width="0.497" height="2.194" transform="translate(0.048 14.634)"/><path d="M.593,32.8H0V30.51H.593Zm-.478-.1H.478v-2.1H.1Z" transform="translate(0 -15.924)"/><rect width="0.497" height="2.194" transform="translate(0.048 10.948)"/><path d="M.593,25.09H0V22.8H.593Zm-.478-.1H.478V22.9H.1Z" transform="translate(0 -11.9)"/><rect width="0.497" height="2.194" transform="translate(0.048 7.262)"/><path d="M.593,17.375H0V15.09H.593Zm-.478-.1H.478V15.186H.1Z" transform="translate(0 -7.876)"/><rect width="0.497" height="2.194" transform="translate(0.048 3.571)"/><path d="M.593,9.66H0V7.37H.593ZM.1,9.584H.478V7.466H.1Z" transform="translate(0 -3.846)"/><path d="M.1,1.944V.509A.478.478,0,0,1,.578.06H2.3V.538H.607V1.944Z" transform="translate(-0.052 -0.031)"/><path d="M.6,1.965H0V.478A.507.507,0,0,1,.512,0H2.3V.583H.6ZM.1,1.869H.507V.478H2.2V.1H.512A.411.411,0,0,0,.1.478Z" transform="translate(0 0)"/><rect width="2.194" height="0.497" transform="translate(3.485 0.048)"/><path d="M9.49.593H7.19V0h2.3ZM7.286.478h2.1V.1h-2.1Z" transform="translate(-3.753 0)"/><rect width="2.194" height="0.497" transform="translate(7.171 0.048)"/><path d="M17.19.593H14.9V0h2.29ZM15,.478h2.1V.1H15Z" transform="translate(-7.776 0)"/><rect width="2.194" height="0.497" transform="translate(10.857 0.048)"/><path d="M24.9.593H22.61V0H24.9ZM22.706.478h2.1V.1h-2.1Z" transform="translate(-11.8 0)"/><rect width="2.194" height="0.497" transform="translate(14.548 0.048)"/><path d="M32.615.593H30.33V0h2.285ZM30.426.478H32.52V.1H30.426Z" transform="translate(-15.83 0)"/><rect width="2.194" height="0.497" transform="translate(18.234 0.048)"/><path d="M40.309.593H38V0h2.29ZM38.115.478h2.1V.1h-2.1Z" transform="translate(-19.833 0)"/><path d="M46.19.1h1.434a.478.478,0,0,1,.449.478V1.826H47.6V.607H46.19Z" transform="translate(-24.107 -0.052)"/><path d="M48.055,1.822h-.574V.6H46.09V0h1.468a.507.507,0,0,1,.478.512Zm-.478-.1h.382V.512a.411.411,0,0,0-.4-.416H46.186V.507h1.377Z" transform="translate(-24.055 0)"/><rect width="0.497" height="2.194" transform="translate(23.455 3.485)"/><path d="M49.574,9.49H49V7.19h.574Zm-.5-.091h.406V7.286h-.406Z" transform="translate(-25.574 -3.753)"/><rect width="0.497" height="2.194" transform="translate(23.455 7.171)"/><path d="M49.574,17.19H49V14.9h.574Zm-.5-.1h.406V15h-.406Z" transform="translate(-25.574 -7.776)"/><rect width="0.497" height="2.194" transform="translate(23.455 10.857)"/><path d="M49.574,24.9H49V22.61h.574Zm-.5-.1h.406v-2.1h-.406Z" transform="translate(-25.574 -11.8)"/><rect width="0.497" height="2.194" transform="translate(23.455 14.548)"/><path d="M49.574,32.615H49V30.33h.574Zm-.5-.1h.406V30.426h-.406Z" transform="translate(-25.574 -15.83)"/><rect width="0.497" height="2.194" transform="translate(23.455 18.234)"/><path d="M49.574,40.309H49V38h.574Zm-.5-.1h.406v-2.1h-.406Z" transform="translate(-25.574 -19.833)"/><path d="M48.216,46.19v1.434a.478.478,0,0,1-.478.449H46.49V47.6h1.2V46.19Z" transform="translate(-24.264 -24.107)"/><path d="M47.7,48.055H46.39v-.574h1.219V46.09h.6v1.468A.507.507,0,0,1,47.7,48.055Zm-1.214-.1H47.7a.411.411,0,0,0,.416-.4V46.186H47.7v1.377H46.486Z" transform="translate(-24.212 -24.055)"/><rect width="2.194" height="0.497" transform="translate(18.32 23.45)"/><path d="M40.505,49.574H38.22V49h2.285Zm-2.19-.1h2.1v-.406h-2.1Z" transform="translate(-19.947 -25.574)"/><rect width="2.194" height="0.497" transform="translate(14.634 23.45)"/><path d="M32.8,49.574H30.51V49H32.8Zm-2.194-.1h2.1v-.406h-2.1Z" transform="translate(-15.924 -25.574)"/><rect width="2.194" height="0.497" transform="translate(10.948 23.45)"/><path d="M25.09,49.574H22.8V49h2.29Zm-2.194-.1h2.1v-.406H22.9Z" transform="translate(-11.9 -25.574)"/><rect width="2.194" height="0.497" transform="translate(7.262 23.45)"/><path d="M17.375,49.574H15.09V49h2.285Zm-2.19-.1H17.28v-.406H15.186Z" transform="translate(-7.876 -25.574)"/><rect width="2.194" height="0.497" transform="translate(3.571 23.45)"/><path d="M9.66,49.574H7.37V49H9.66Zm-2.194-.1H9.584v-.406H7.466Z" transform="translate(-3.846 -25.574)"/><path d="M1.944,48.216H.509a.478.478,0,0,1-.449-.478V46.49H.538v1.2H1.944Z" transform="translate(-0.031 -24.264)"/><path d="M1.965,48.212H.478A.507.507,0,0,1,0,47.7V46.39H.583v1.219H1.965ZM.1,46.486V47.7a.411.411,0,0,0,.382.416H1.869V47.7H.478V46.486Z" transform="translate(0 -24.212)"/><path d="M26,25.1v-.574c2.051,0,2.782-.578,2.782-2.223V10.587c0-1.64-.731-2.218-2.782-2.218V7.79c1.74,0,3.347.339,3.347,2.8V22.3C29.347,24.757,27.74,25.1,26,25.1Z" transform="translate(-13.57 -4.066)"/><path d="M35.177,25.1c-1.74,0-3.347-.339-3.347-2.8V10.587c0-2.457,1.611-2.8,3.347-2.8v.578c-2.051,0-2.787.578-2.787,2.218V22.3c0,1.645.727,2.223,2.778,2.223Z" transform="translate(-16.612 -4.066)"/><rect width="2.194" height="0.497" transform="translate(14.4 16.59)"/><path d="M32.3,35.193H30V34.6h2.29Zm-2.194-.1h2.1v-.4h-2.1Z" transform="translate(-15.657 -18.058)"/></svg>,
    helpVideo: '448967259',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            },
            {
              type: 'image',
              name: 'box_image',
              label: 'Bild'
            },
            {
              type: 'audio',
              name: 'box_audio',
              label: 'Audio'
            }
          ]
        },
        {
          headline: 'Freitextfeld',
          fields: [
            {
              type: 'text',
              name: 'placeholder',
              label: 'Platzhalter'
            },
            {
              type: 'text',
              name: 'limit',
              label: 'Maximiale Zeichenbegrenzung'
            }
          ]
        }
      ]
    }
  },
  {
    type: 'pairs',
    itemType: 'element',
    category: 'quiz',
    title: 'Paar Quiz',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="23.904" height="24" viewBox="0 0 23.904 24"><path d="M8.792,4.4H.535A.531.531,0,0,1,0,3.872V.526A.531.531,0,0,1,.535,0H8.792a.531.531,0,0,1,.535.526V3.872A.531.531,0,0,1,8.792,4.4ZM.583,3.825H8.744V.574H.583Z" transform="translate(0 0)"/><path d="M39.272,4.4H31.015a.531.531,0,0,1-.535-.526V.526A.531.531,0,0,1,31.015,0h8.257a.531.531,0,0,1,.54.526V3.872a.531.531,0,0,1-.54.526Zm-8.209-.574h8.161V.574H31.063Z" transform="translate(-15.908 0)"/><path d="M8.792,18.068H.535A.531.531,0,0,1,0,17.542V14.2a.531.531,0,0,1,.535-.526H8.792a.531.531,0,0,1,.535.526v3.347A.531.531,0,0,1,8.792,18.068ZM.583,17.495H8.744V14.244H.583Z" transform="translate(0 -7.134)"/><path d="M39.272,18.068H31.015a.531.531,0,0,1-.535-.526V14.2a.531.531,0,0,1,.535-.526h8.257a.531.531,0,0,1,.54.526v3.347a.531.531,0,0,1-.54.526Zm-8.209-.574h8.161V14.244H31.063Z" transform="translate(-15.908 -7.134)"/><path d="M8.792,31.728H.535A.531.531,0,0,1,0,31.2V27.856a.531.531,0,0,1,.535-.526H8.792a.531.531,0,0,1,.535.526V31.2A.531.531,0,0,1,8.792,31.728ZM.583,31.155H8.744V27.9H.583Z" transform="translate(0 -14.264)"/><path d="M39.272,31.728H31.015a.531.531,0,0,1-.535-.526V27.856a.531.531,0,0,1,.535-.526h8.257a.531.531,0,0,1,.54.526V31.2a.531.531,0,0,1-.54.526Zm-8.209-.574h8.161V27.9H31.063Z" transform="translate(-15.908 -14.264)"/><path d="M8.792,45.4H.535A.531.531,0,0,1,0,44.872V41.526A.531.531,0,0,1,.535,41H8.792a.531.531,0,0,1,.535.526v3.347A.531.531,0,0,1,8.792,45.4ZM.583,44.825H8.744V41.574H.583Z" transform="translate(0 -21.398)"/><path d="M39.272,45.4H31.015a.531.531,0,0,1-.535-.526V41.526A.531.531,0,0,1,31.015,41h8.257a.531.531,0,0,1,.54.526v3.347a.531.531,0,0,1-.54.526Zm-8.209-.574h8.161V41.574H31.063Z" transform="translate(-15.908 -21.398)"/><path d="M18.615,31.276a.33.33,0,0,1-.115,0,.3.3,0,0,1-.153-.378l5.794-13.7a.287.287,0,1,1,.526.225L18.878,31.1A.292.292,0,0,1,18.615,31.276Z" transform="translate(-9.565 -8.873)"/><path d="M18.615,11.111a.3.3,0,0,1-.186-.067.287.287,0,0,1-.033-.406l5.79-6.88a.287.287,0,1,1,.44.368l-5.79,6.865A.292.292,0,0,1,18.615,11.111Z" transform="translate(-9.564 -1.908)"/><path d="M24.386,18.3a.282.282,0,0,1-.263-.177L18.348,4.444a.3.3,0,0,1,.153-.378.292.292,0,0,1,.378.153l5.79,13.668a.292.292,0,0,1-.263.4Z" transform="translate(-9.565 -2.111)"/><path d="M24.364,38.095a.3.3,0,0,1-.225-.105l-5.79-7.171a.287.287,0,0,1,.445-.363l5.794,7.171a.287.287,0,0,1-.225.478Z" transform="translate(-9.543 -15.84)"/></svg>,
    helpVideo: '448967522',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            }
          ]
        },
        {
          description: 'Erstellen Sie die zueinander gehörigen Paare!',
          fields: [
            {
              type: 'repeater',
              name: 'pairs',
              label: 'Paare',
              addItemLabel: 'Paar hinzufügen',
              fields: [
                {
                  type: 'text',
                  name: 'text_1',
                  label: 'Text'
                },
                {
                  type: 'text',
                  name: 'text_2',
                  label: 'Text'
                }
              ],
              defaultValue: [
                {
                  settings: {}
                },
                {
                  settings: {}
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    type: 'slide_control',
    itemType: 'element',
    category: 'quiz',
    title: 'Schieberegler',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="7.184" viewBox="0 0 32 7.184"><path d="M19.74,5.77H38.694a.385.385,0,1,0,0-.77H19.753Z" transform="translate(-7.079 -1.793)"/><path d="M6.17,5.77H.385a.385.385,0,0,1,0-.77H6.158Z" transform="translate(0 -1.793)"/><path d="M12.612,7.184A3.592,3.592,0,1,1,16.2,3.592a3.592,3.592,0,0,1-3.592,3.592Zm0-6.414a2.822,2.822,0,1,0,2.809,2.822A2.822,2.822,0,0,0,12.612.77Z" transform="translate(-3.234)"/></svg>,
    helpVideo: '448967642',
    settings: {
      sections: [
        {
          headline: 'Titel',
          fields: [
            {
              type: 'switch',
              name: 'box_show',
              label: 'Anzeigen',
              defaultValue: true
            },
            {
              type: 'text',
              name: 'box_headline',
              label: 'Titel'
            },
            {
              type: 'textarea',
              name: 'box_text',
              label: 'Text'
            }
          ]
        },
        {
          headline: 'Bild',
          fields: [
            {
              type: 'image',
              name: 'image',
              label: 'Bild'
            }
          ]
        },
        {
          headline: 'Punkte',
          fields: [
            {
              type: 'text',
              name: 'point_left',
              label: 'linker Punkt'
            },
            {
              type: 'text',
              name: 'point_right',
              label: 'rechter Punkt'
            }
          ]
        }
      ]
    }
  }
]

export default CONFIG_ELEMENTS
